import { inject, Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subscription } from 'rxjs';
import { tap } from 'rxjs/operators';
import {
  collection,
  Firestore,
  CollectionReference,
  doc,
  DocumentReference,
  docData,
  setDoc,
} from '@angular/fire/firestore';

export interface SmartWeatherSession {
  memberNumber: string | undefined;
  pusherId: number | undefined;
  updated: number;
  state: string;
}

@Injectable({ providedIn: 'root' })
export class StateSyncService {
  firestore = inject(Firestore);
  state$: Observable<SmartWeatherSession | null> | undefined;
  memberNumber: string | undefined;
  pusherId: number | undefined;

  private stateSubject: BehaviorSubject<SmartWeatherSession> | BehaviorSubject<null> | undefined;
  private swSessionCollectionRef: CollectionReference | undefined;
  private swSessionDocRef: DocumentReference<SmartWeatherSession> | undefined;
  private swSession$: Observable<SmartWeatherSession | null | undefined> | undefined;
  private swSessionSubscription: Subscription | undefined;

  setupService(clubId: string, memberNumber: string): void {
    this.memberNumber = memberNumber;
    this.pusherId = Date.now() * 10000 + Math.floor(Math.random() * Math.floor(10000));
    this.stateSubject = new BehaviorSubject(null);
    this.state$ = this.stateSubject.asObservable();

    // this.swSessionCollectionRef = this.afs
    //   .collection('wss-aaa-web')
    //   .doc(clubId)
    //   .collection('apps')
    //   .doc('smart-weather')
    //   .collection('sessions');
    // this.swSessionDocRef = this.swSessionCollectionRef.doc(memberNumber);
    // this.swSession$ =
    //   this.swSessionDocRef.valueChanges().pipe(
    //     tap((sessionDoc: SmartWeatherSession | undefined | null) => {
    //       if (sessionDoc && this.stateSubject) {
    //         const state = JSON.parse(sessionDoc.state);
    //         if (sessionDoc.pusherId !== this.pusherId) {
    //           // console.log(state)
    //           this.stateSubject.next(state as never);
    //         }
    //       }
    //     }),
    //   ) || of(null);
    // this.swSessionSubscription = this.swSession$.subscribe();
    // Todo: need to test
    this.swSessionCollectionRef = collection(this.firestore, `wss-aaa-web/${clubId}/apps/smart-weather/sessions`);

    this.swSessionDocRef = doc(this.swSessionCollectionRef, memberNumber) as DocumentReference<SmartWeatherSession>;

    this.swSession$ = docData(this.swSessionDocRef).pipe(
      // @ts-ignore
      tap((sessionDoc: SmartWeatherSession | undefined) => {
        if (sessionDoc && this.stateSubject) {
          const state = JSON.parse(sessionDoc.state);

          if (sessionDoc.pusherId !== this.pusherId) {
            this.stateSubject.next(state as never);
          }
        }
      }),
    );

    this.swSessionSubscription = this.swSession$.subscribe();
  }

  unsubscribe(): void {
    if (this.swSessionSubscription) {
      this.swSessionSubscription?.unsubscribe();
    }
  }

  pushState(state: never): void {
    // if (state.context.locations) console.log('location.name[]: ' + [...state.context.locations.map(location => location.name)])
    const stateDoc: SmartWeatherSession = {
      memberNumber: this.memberNumber,
      pusherId: this.pusherId,
      updated: Date.now(),
      state: JSON.stringify(state),
    };
    // this.swSessionDocRef
    //   ?.set(stateDoc, { merge: true })
    //   .then(() => {
    //     //
    //   })
    //   .catch(() => {
    //     //
    //   });
    // Todo: need to test
    if (this.swSessionDocRef) {
      setDoc(this.swSessionDocRef, stateDoc, { merge: true })
        .then(() => {
          //
        })
        .catch(() => {
          //
        });
    }
  }
}
